/**
 * Route for `score-based-routing-fraud-score-auto-allow-flag-bl`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ScoreBasedRoutingFraudScoreAutoAllowFlagBlPage } from "../features/score-based-routing-fraud-score-auto-allow-flag-bl/ScoreBasedRoutingFraudScoreAutoAllowFlagBlPage";

export const scoreBasedRoutingFraudScoreAutoAllowFlagBlRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/score-based-routing-fraud-score-auto-allow-flag-bl",
	component: ScoreBasedRoutingFraudScoreAutoAllowFlagBlPage,
});

export default scoreBasedRoutingFraudScoreAutoAllowFlagBlRoute;
